import styles from "./styles.module.scss";
import { FC } from "react";
import { Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import PackageThread from "components/PackageThread";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import { useTranslation } from "react-i18next";

const PackageThreadModal: FC<Props> = ({
  threadId,
  itemId,
  toggle,
}) => {
  const { t } = useTranslation();
  return (
    <ModalLayout
      dock={DockPosition.FULLSCREEN_CENTER}
      customY={10}
      isAnimation={false}
      ignore={false}
      toggle={() => toggle(false)}
      refWrapper={undefined}
      showBg={true}
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {t("packages.threadPreview")}
          <CloseIcon
            onClick={() => toggle(false)}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <PackageThread
            threadIdOverride={threadId}
            threadPackageIdOverride={itemId}
            showHeader={false}
          ></PackageThread>
        </div>
      </div>
    </ModalLayout>
  );
};

export default PackageThreadModal;
